<template>
    <b-col cols="12">
        <h5>Abonado {{ numero }} {{ total | formatear_precio }} 
            {{ (descuento_aplicado || descuento_integro) && !abono.plazos ? ' (' + ((descuento_aplicado ? descuento_aplicado + '%' : $n(descuento_integro, "currency")) + ' de descuento)') : '' }}
        </h5>
        <ValidationObserver tag="form" ref="observer">
            <b-row>
                <template v-for="metodo in metodos_pago">
                    <b-col cols="12" class="mb-3" :key="metodo.valor" >
                        <ValidationProvider :name="metodo.texto" rules="required|double" v-slot="{ errors }">
                            <label>{{ metodo.texto }}</label>
                            <b-form-input
                                v-model="metodo.importe"
                                :placeholder="metodo.texto"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                @change="submit"
                                :disabled="disabled"
                            />
                        </ValidationProvider>
                    </b-col>
                </template>
                <b-col cols="12" v-if="error">
                    <b-alert show variant="danger">La suma de los importes debe sumar el importe exacto del precio del abono.</b-alert>
                </b-col>
            </b-row>
        </ValidationObserver>
    </b-col>
</template>

<script>
    export default {
        props: {
            abono: {
                type: Object,
                required: true
            },
            importe: {
                type: Number,
                required: true
            },
            descuento_aplicado: {
                type: Number,
                required: false
            },
            descuento_integro: {
                type: Number,
                required: false
            },
            metodos_pago: {
                type: Array,
                required: true
            },
            numero: {
                type: Number,
                required: true
            },
            disabled: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                error: false
            }
        },
        mounted() {
            this.initPrices()
            this.submit();
        },
        watch: {
            metodos_pago() {
                this.initPrices();
            }
        },
        computed: {
            total() {
                let importe = this.abono.plazos_pendientes && this.abono.plazos_pendientes.length > 0 ? this.abono.plazos_pendientes[0].importe : this.importe;
                let total = 0;

                if (this.descuento_aplicado && !this.abono.plazos) {
                    total += importe - (this.importe * (this.descuento_aplicado / 100));
                } else if (this.descuento_integro && !this.abono.plazos) {
                    total += importe - this.descuento_integro;
                } else {
                    total += importe;
                }

                return parseFloat(total.toFixed(2));
            }
        },
        methods: {
            initPrices() {
                this.metodos_pago.forEach(metodo => {
                    metodo.importe = 0;
                })
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    let total = 0;
                    this.metodos_pago.forEach(metodo => {
                        total += parseFloat(metodo.importe);
                    })

                    if(total.toFixed(2) != parseFloat(this.total)) {
                        this.error = true;
                        this.$emit('error', true);
                    } else {
                        this.error = false;
                        this.metodos_pago.forEach(metodo_pago => {
                            metodo_pago.importe = parseFloat(metodo_pago.importe);
                        });
                        this.$emit('valido', this.metodos_pago);
                        this.$emit('error', false)
                    }
                } else {
                    this.error = true
                    this.$emit('error', true);
                }
            },
        }
    }
</script>